import hotkeys from 'hotkeys-js';
import { useEffect, useRef } from 'react';

export const useKeyPressListener = (keys: string[], handler: Function) => {
    // 创建一个 ref 来存储处理程序
    const saveHandler = useRef<Function>(handler);

    // 如果 handler 变化了，就更新 ref.current 的值。
    // 这个让我们下面的 effect 永远获取到最新的 handler
    useEffect(() => {
        saveHandler.current = handler;
    }, [handler]);

    useEffect(
        () => {
            // 确保元素支持 addEventListener
            if (!saveHandler.current) {
                return;
            }

            // 创建事件监听调用存储在 ref 的处理方法
            const eventListener = (e: Event, handler: any) => {
                e.preventDefault();

                saveHandler.current(hotkeys, e, handler);
            };

            hotkeys(keys.join(','), eventListener);

            // 清除的时候移除事件监听
            return () => {
                hotkeys.unbind(keys.join(','), eventListener);
            };
        },
        [keys], // 如果 eventName 或 element 变化，就再次运行
    );
};
